export default "__VITE_ASSET__Vkc74lAZ__"